<template>
  <div class="user-table-container">
    <table class="user-table">
      <thead>
      <tr>
        <th class="th-sorter name"
            :class="{active: sortKey === 'name'}"
            rowspan="3"
            @click="sortBy('name')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.name') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th :colspan="numberOfCols" class="working-hours">
          <div>{{ $t('vue2.assign_users_hours.work_hours') }}</div>
        </th>
        <th colspan="1" class="rest-hours" v-if="isShowRestColumnFinal">Rest</th>
        <th :colspan="numberOfCols" class="teaching-hours">
          <div>{{ $t('vue2.assign_users_hours.teaching') }}</div>
        </th>
        <th :colspan="numberOfCols" class="task-hours" v-if="isSchoolYearWithNewEmploymentDeal">
          <div>{{ $t('vue2.assign_users_hours.tasks') }}</div>
        </th>
        <th :colspan="numberOfCols" class="prep-hours" v-if="isSchoolYearWithNewEmploymentDeal">
          {{ $t('vue2.assign_users_hours.preparation') }}
        </th>
        <th :colspan="numberOfCols" class="prep-hours" v-if="isLocalPoolActivated">
          {{ localPoolTitle }}
        </th>
        <th colspan="1" class="absence-hours">{{ $t('vue2.assign_users_hours.absence') }}</th>
        <th :colspan="numberOfCols" class="sub-hours">{{ $t('vue2.assign_users_hours.substitute_hours') }}</th>
        <th :colspan="numberOfCols" class="club-hours" v-if="isSFOActive">
          <div>{{ $t('vue2.task_overview.club') }}</div>
        </th>
      </tr>
      <tr>
        <!-- ARBEJDSTID -->
        <th class="th-sorter assigned_total_hours"
            :class="{active: sortKey === 'assigned_total_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('assigned_total_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter actual_total_hours"
            :class="{active: sortKey === 'actual_total_hours'}"
            @click="sortBy('actual_total_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter diff_total_hours"
            :class="{active: sortKey === 'diff_total_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('diff_total_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <!-- REST -->
        <th class="th-sorter rest_hours"
            :class="{active: sortKey === 'rest_hours'}"
            v-if="isShowRestColumnFinal"
            @click="sortBy('rest_hours')">
          <div class="column-width">Rest
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <!-- UNDERVISNING -->
        <th class="th-sorter assigned_teaching_hours"
            :class="{active: sortKey === 'assigned_teaching_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('assigned_teaching_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter actual_teaching_hours"
            :class="{active: sortKey === 'actual_teaching_hours'}"
            @click="sortBy('actual_teaching_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter diff_teaching_hours"
            :class="{active: sortKey === 'diff_teaching_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('diff_teaching_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <!-- ØVRIGE OPGAVER -->
        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <th class="th-sorter assigned_additional_task_hours"
              :class="{active: sortKey === 'assigned_additional_task_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('assigned_additional_task_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter actual_additional_task_hours"
              :class="{active: sortKey === 'actual_additional_task_hours'}"
              @click="sortBy('actual_additional_task_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter diff_additional_task_hours"
              :class="{active: sortKey === 'diff_additional_task_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('diff_additional_task_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
        </template>
        <!-- FORBEREDELSE -->
        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <th class="th-sorter assigned_preparation_hours"
              :class="{active: sortKey === 'assigned_preparation_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('assigned_preparation_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter actual_preparation_hours"
              :class="{active: sortKey === 'actual_preparation_hours'}"
              @click="sortBy('actual_preparation_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter diff_preparation_hours"
              :class="{active: sortKey === 'diff_preparation_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('diff_preparation_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
        </template>
        <!-- LOKALPULJE -->
        <template v-if="isLocalPoolActivated">
          <th class="th-sorter assigned_pool_hours"
              :class="{active: sortKey === 'assigned_pool_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('assigned_pool_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter actual_pool_hours"
              :class="{active: sortKey === 'actual_pool_hours'}"
              @click="sortBy('actual_pool_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter diff_pool_hours"
              :class="{active: sortKey === 'diff_pool_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('diff_pool_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
        </template>
        <!-- FRAVÆR -->
        <th class="th-sorter actual_absence_hours"
            :class="{active: sortKey === 'actual_absence_hours'}"
            @click="sortBy('actual_absence_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <!-- VIKATIMER -->
        <th class="th-sorter substitute_pool_hours"
            :class="{active: sortKey === 'substitute_pool_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('substitute_pool_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter actual_substitute_hours"
            :class="{active: sortKey === 'actual_substitute_hours'}"
            @click="sortBy('actual_substitute_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <th class="th-sorter diff_substitute_hours"
            :class="{active: sortKey === 'diff_substitute_hours'}"
            v-if="viewSettings.show_assigned.active"
            @click="sortBy('diff_substitute_hours')">
          <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
            <span class="icon-menu-open"></span>
          </div>
        </th>
        <!-- CLUB -->
        <template v-if="isSFOActive">
          <th class="th-sorter assigned_club_hours"
              :class="{active: sortKey === 'assigned_club_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('assigned_club_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.assigned') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter actual_club_hours"
              :class="{active: sortKey === 'actual_club_hours'}"
              @click="sortBy('actual_club_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.scheduled') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
          <th class="th-sorter diff_club_hours"
              :class="{active: sortKey === 'diff_club_hours'}"
              v-if="viewSettings.show_assigned.active"
              @click="sortBy('diff_club_hours')">
            <div class="column-width">{{ $t('vue2.assign_users_hours.diff') }}
              <span class="icon-menu-open"></span>
            </div>
          </th>
        </template>
      </tr>
      </thead>
      <tbody class="user-table__body">
      <tr v-for="user in filteredData"
          :key="user.id"
          class="tr-user"
          :class="{'tr-user--cant-edit': !theUserCanManageAssignedHours || (isPoolsDeactivated && !isAssignedPoolFromNormWhenPoolsDeactivated)}">
        <th class="tr-user__name">
          <div class="tr-user__name__inner">
            <p>{{ user.name }}</p>
            <div class="tr-user__name__bttn icon__bg-circle hint--right"
                 @click="setTheUserToShowTasksFor(user)"
                 :aria-label="$t('vue2.task_overview.task_and_hour_overview')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-chart tw-icon tw-icon--small">
                <path class="primary"
                      d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"/>
                <path class="secondary"
                      d="M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"/>
              </svg>
            </div>
          </div>
        </th>

        <td class="number number_edit td-presence"
            @click.stop="openEditFromRow(user, user.assigned_total_hours, 'assigned_total_hours', $event)"
            :class="{'is-number--calculated': !isDatesPristine}"
            :content='createTooltip(user.assigned_total_hours)'
            v-if="viewSettings.show_assigned.active"
            v-tippy="{
                    arrow: true,
                    animateFill: false,
                    animation : 'shift-away',
                    zIndex: '999999992',
                    boundary: 'window',
                    onShow: () => !isDatesPristine
                  }">
          <span class="icon-clock" v-if="!isDatesPristine"></span>
          {{ user.v_total_hours_assigned_in_period }}
        </td>
        <td class="number td-presence"
            :class="{'td-presence--pedagog': user.vIsPedagogog}"
            :aria-label="user.actual_total_hours"
            content="For pædagoger tælles arbejdstid som summen af alle skemalagte timer i kalenderen – uanset om de er sat som undervisning, SFO, vikar eller andre opgaver."
            v-tippy="{
                    placement: 'right',
                    arrow: true,
                    animateFill: false,
                    animation : 'shift-away',
                    zIndex: '999999992',
                    boundary: 'window',
                    onShow: () => user.vIsPedagogog === true
                  }">
        </td>
        <td class="number td-presence number__scale-indicator" v-if="viewSettings.show_assigned.active"
            :style="scaleIndicator(user.diff_total_hours)"
            :aria-label="user.diff_total_hours">
        </td>

        <td class="number pointer td-rest number__scale-indicator"
            v-if="isShowRestColumnFinal"
            :style="scaleIndicator(user.rest_hours)"
            :aria-label="user.rest_hours"
            v-tippy="{
          content: `<div>
                      <div class='do-flex-labels'>Arbejdstid: <span>${user.assigned_total_hours}</span></div>
                      <div class='do-flex-labels'>Tildelte timer: <span>${user.sum_hours}</span></div>
                    </div>`,
          allowHTML: true,
          arrow: true,
          placement: 'left'
        }">
        </td>

        <td class="number number_edit td-teaching"
            v-if="viewSettings.show_assigned.active"
            :aria-label="user.assigned_teaching_hours"
            @click.stop="openEditFromRow(user, user.assigned_teaching_hours, 'assigned_teaching_hours', $event)">
        </td>
        <td class="number td-teaching" :aria-label="user.actual_teaching_hours">
        </td>
        <td class="number number__scale-indicator td-teaching" v-if="viewSettings.show_assigned.active"
            :style="scaleIndicator(user.diff_teaching_hours)"
            :aria-label="user.diff_teaching_hours">
        </td>

        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <td class="number number_edit td-tasks"
              :aria-label="user.assigned_additional_task_hours"
              v-if="viewSettings.show_assigned.active"
              @click.stop="openEditFromRow(user, user.assigned_additional_task_hours, 'assigned_additional_task_hours', $event)">
          </td>
          <td class="number td-tasks" :aria-label="user.actual_additional_task_hours">
          </td>
          <td class="number number__scale-indicator td-tasks" v-if="viewSettings.show_assigned.active"
              :style="scaleIndicator(user.diff_additional_task_hours)"
              :aria-label="user.diff_additional_task_hours">
          </td>
        </template>

        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <td class="number number_edit td-preparation"
              :aria-label="user.assigned_preparation_hours"
              v-tippy="{
          content: getPrepFactorTooltipContent(user),
          arrow: true,
          placement: 'top',
          onShow: () => isShowPrepFactorCalculation
        }"
              v-if="viewSettings.show_assigned.active"
              @click.stop="openEditFromRow(user, user.assigned_preparation_hours, 'assigned_preparation_hours', $event)">
          </td>
          <td class="number td-preparation" :aria-label="user.actual_preparation_hours">
          </td>
          <td class="number number__scale-indicator td-preparation" v-if="viewSettings.show_assigned.active"
              :style="scaleIndicator(user.diff_preparation_hours)"
              :aria-label="user.diff_preparation_hours">
          </td>
        </template>

        <!-- LOKALPULJE -->
        <template v-if="isLocalPoolActivated">
          <td class="number number_edit td-preparation"
              :aria-label="user.assigned_pool_hours"
              v-if="viewSettings.show_assigned.active"
              @click.stop="openEditFromRow(user, user.assigned_pool_hours, 'assigned_pool_hours', $event)">
          </td>
          <td class="number td-preparation" :aria-label="user.actual_pool_hours">
          </td>
          <td class="number number__scale-indicator td-preparation"
              v-if="viewSettings.show_assigned.active"
              :style="scaleIndicator(user.diff_pool_hours)"
              :aria-label="user.diff_pool_hours">
          </td>
        </template>

        <td class="number pointer td-absence" @click.stop="setActiveUserFor(user, 'absence')">
          <div class="tr-user__text">
            {{ user.actual_absence_hours }}
          </div>
        </td>

        <td class="number number_edit td-sub-hours"
            :aria-label="user.substitute_pool_hours"
            v-if="viewSettings.show_assigned.active"
            @click.stop="openEditFromRow(user, user.substitute_pool_hours, 'substitute_pool_hours', $event)">
        </td>
        <td class="number pointer td-sub-hours" @click.stop="setActiveUserFor(user, 'substituteHours')"
            :aria-label="user.actual_substitute_hours">
        </td>
        <td class="number number__scale-indicator td-sub-hours"
            v-if="viewSettings.show_assigned.active"
            :style="scaleIndicator(user.diff_substitute_hours)"
            :aria-label="user.diff_substitute_hours">
        </td>
        <template v-if="isSFOActive">
          <td class="number number_edit td-club"
              v-if="viewSettings.show_assigned.active"
              :aria-label="user.assigned_club_hours"
              @click.stop="openEditFromRow(user, user.assigned_club_hours, 'assigned_club_hours', $event)">
          </td>
          <td class="number td-club" :aria-label="user.actual_club_hours">
          </td>
          <td class="number number__scale-indicator td-club"
              v-if="viewSettings.show_assigned.active"
              :style="scaleIndicator(user.diff_club_hours)"
              :aria-label="user.diff_club_hours">
          </td>
        </template>
      </tr>
      </tbody>
    </table>
    <div class="popper_child" ref="popper_child" v-if="theEditNumberUserId">
      <transition name="scale">
        <div class="number__input-opened" v-if="isDropdownPopperDone">
          <input type="number"
                 v-model.lazy="theEditNumberNumber"
                 v-focus
                 v-on-clickaway="closeEditing"
                 @keyup.enter="doneEditing"/>
          <button class="bttn bttn--primary" :class="{'bttn--small--loading': isUpdatingNumber}"
                  @click.stop="doneEditing">
            <span v-if="!isUpdatingNumber">{{ $t('vue2.common.save') }}</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {createPopper} from '@popperjs/core' // eslint-disable-line no-unused-vars
import {mixin as clickaway} from 'vue-clickaway'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import {isPoolHoursEditableWhenPoolsDeactivated} from '../../utils/assignedPoolWhenPoolsDeactivated'

const I18N = {
  da: {
    tooltip: {
      hours: 'timer',
      days: 'dage',
      work_days: 'arbejdsdage',
      per_day: 'pr. dag',
      calculation: 'Beregning',
      forYear: 'For året:',
      forPeriod: 'For perioden:',
      explanation: '<p><i>Når du vælger et andet datointerval end hele perioden, kan du her se, hvor mange timer, der i gennemsnit skal planlægges for medarbejderen i perioden og per dag. Udregningen er baseret på antal arbejdsdage angivet for personalet, fratrukket weekender, feriedage og helligdage i \'Feriekalender\'</p>'
    }
  },
  nb: {
    tooltip: {
      hours: 'timer',
      days: 'dager',
      per_day: 'per dag',
      work_days: 'arbeidsdager',
      calculation: 'Beregning',
      forYear: 'For året:',
      forPeriod: 'For perioden:',
      explanation: '<p><i>Når du velger et annet datointerval enn hele året, kan du her se, hvor mange timer som skal planlegges for medarbeideren i perioden og i gjennomsnitt per dag. Beregningen trekker helger og ferie- og helligdager fra.</i></p>'
    }
  },
  en: {
    tooltip: {
      hours: 'hours',
      days: 'days',
      per_day: 'per day',
      work_days: 'work days',
      calculation: 'Calculation',
      forYear: 'For the year:',
      forPeriod: 'For the period:',
      explanation: '<p><i>When you choose a different date range than the whole year, you can see here how many hours need to be planned for the employee in the period and on average per day. The calculation subtracts weekends and holidays.</i></p>'
    }
  }
}

export default {
  mixins: [clickaway],
  props: {
    theUserCanManageAssignedHours: {
      default: false
    },
    schoolid: {},
    users: {
      type: Array,
      default: []
    },
    isDatesPristine: {
      type: Boolean,
      default: true
    },
    isLocalPoolActivated: {
      type: Boolean,
      default: false
    },
    numberOfWorkDaysInPeriod: {
      required: true
    },
    numberOfWorkDays: {
      required: true
    },
    locale: {
      default: 'en'
    },
    viewSettings: {
      type: Object
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    },
    isShowRestColumn: {
      type: Boolean,
      default: false
    },
    prepFactor: {
      default: null
    },
    isPrepFactorForSubstitutePools: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sortKey: 'name',
      sortOrder: 1,
      theEditNumberUserId: null,
      theEditNumberType: '',
      theEditNumberNumber: 0,
      isDropdownPopperDone: false,
      isUpdatingNumber: false
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
        el.select()
      }
    }
  },
  computed: {
    isAssignedPoolFromNormWhenPoolsDeactivated () {
      return this.$store.getters.isAssignedPoolFromNormWhenPoolsDeactivated
    },
    numberOfCols () {
      const isShowAssignedActivated = this.viewSettings['show_assigned']['active']
      return isShowAssignedActivated ? 3 : 1
    },
    isSFOActive () {
      return this.$store.getters.isSchoolSFOActive
    },
    filteredData () {
      var sortKey = this.sortKey
      var order = this.sortOrder
      var data = this.users
      if (sortKey && sortKey !== 'name') {
        data = data.sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          if (order < 0) {
            return a - b
          } else {
            return b - a
          }
        })
      } else {
        return this.$helpers.sortArrOnName(data)
      }
      return data
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isSchoolYearWithNewEmploymentDeal () {
      return moment(this.$store.state.localActivatedSchoolYear.employee_time_start).isAfter('2021-01-01') || moment(this.$store.state.localActivatedSchoolYear.student_time_start).isAfter('2021-01-01')
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    i18n () {
      return I18N[this.locale]
    },
    isShowPrepFactorCalculation () {
      return this.prepFactor !== null && this.isPoolsDeactivated && this.locale === 'da'
    },
    isShowRestColumnFinal () {
      return this.isPoolsDeactivated || this.isShowRestColumn
    }
  },
  methods: {
    createPopper (parentPopper, childPopper) {
      parentPopper.appendChild(childPopper)
    },
    setOpenEdit (obj) {
      this.isDropdownPopperDone = false
      this.theEditNumberUserId = obj.userId
      this.theEditNumberType = obj.type
      this.theEditNumberNumber = obj.number
      this.$nextTick(_ => {
        this.createPopper(obj.evt.target, this.$refs.popper_child)
        this.isDropdownPopperDone = true
      })
    },
    sortBy (key) {
      this.sortKey = key
      this.sortOrder = this.sortOrder * -1
    },
    updatedUser (user) {
      this.$emit('updatedUser', user)
    },
    setActiveUser (userAndFilter) {
      this.$emit('setActiveUser', userAndFilter)
    },
    setTheUserToShowTasks (user) {
      this.$emit('setTheUserToShowTasks', user)
    },
    closeEditing () {
      this.isDropdownPopperDone = false
      this.theEditNumberUserId = null
      this.theEditNumberType = ''
      this.theEditNumberNumber = 0
    },
    doneEditing () {
      this.docendoEditHours()
    },
    docendoEditHours () {
      this.isUpdatingNumber = true
      const key = this.theEditNumberType
      let updateVal = {[key]: this.theEditNumberNumber}
      const user = this.users.find(user => user.id === this.theEditNumberUserId)
      const isEditingTeaching = key === 'assigned_teaching_hours'
      // Ved deaktiverede puljer er forberedelsen afledt af brikkerne, så der skrives ikke
      // automatisk til assigned_preparation_hours ved redigering af vikartimer.
      const isEditingSubstituteWithPrep = this.isPrepFactorForSubstitutePools && key === 'substitute_pool_hours' && !this.isPoolsDeactivated
      const updatePrepWithPrepFactor = this.prepFactor && (isEditingTeaching || isEditingSubstituteWithPrep) && !user.vNoPrepFactor
      let thePrep = null
      if (updatePrepWithPrepFactor) {
        const toNum = val => {
          const n = parseFloat(val)
          return isNaN(n) ? 0 : n
        }
        const teachingHours = isEditingTeaching ? toNum(this.theEditNumberNumber) : toNum(user.assigned_teaching_hours)
        const substituteHours = this.isPrepFactorForSubstitutePools
          ? (key === 'substitute_pool_hours' ? toNum(this.theEditNumberNumber) : toNum(user.substitute_pool_hours))
          : 0
        thePrep = parseFloat(((teachingHours + substituteHours) * this.prepFactor).toFixed(2))
        updateVal = {
          [key]: this.theEditNumberNumber,
          assigned_preparation_hours: thePrep
        }
      }
      docendo.schoolUserYearUpdate(this.schoolid, this.theEditNumberUserId, this.activeSchoolYear.name, updateVal,
        success => {
          if (updatePrepWithPrepFactor) {
            eventbus.toast = {
              text: 'Gemt & automatisk opdateret forberedelsestid til ' + thePrep + ' timer',
              'success': true
            }
          }
          this.isUpdatingNumber = false
          this.closeEditing()
          this.$emit('updatedUser', success)
        })
    },
    isPoolHoursEditableWhenPoolsDeactivated (type) {
      return isPoolHoursEditableWhenPoolsDeactivated(type, this.$store.state.schoolSettings)
    },
    setTheUserToShowTasksFor (user) {
      this.$emit('setTheUserToShowTasks', user)
    },
    setActiveUserFor (user, filter) {
      this.$emit('setActiveUser', {user: user, filter: filter})
    },
    openEditFromRow (user, num, type, evt) {
      if (!this.theUserCanManageAssignedHours || (this.isPoolsDeactivated && !this.isPoolHoursEditableWhenPoolsDeactivated(type))) {
        return
      }
      this.setOpenEdit({
        userId: user.id,
        number: num,
        type: type,
        evt: evt
      })
    },
    getPrepFactorTooltipContent (user) {
      if (user.vNoPrepFactor) {
        return 'Ingen foredelsesfaktor for denne gruppe'
      }
      if (this.isPoolsDeactivated && this.locale === 'da') {
        if (this.isPrepFactorForSubstitutePools) {
          return user.assigned_teaching_hours + ' UV-timer med forberedelsesfaktor (skole / fag / opgave) + ' + user.substitute_pool_hours + ' vikartimer * ' + this.prepFactor
        }
        return user.assigned_teaching_hours + ' UV-timer med forberedelsesfaktor (skole / fag / opgave)'
      }
      if (this.isPrepFactorForSubstitutePools) {
        return '(' + user.assigned_teaching_hours + ' UV-timer + ' + user.substitute_pool_hours + ' vikartimer) * ' + this.prepFactor + ' forberedelsesfaktor'
      }
      return user.assigned_teaching_hours + ' UV-timer * ' + this.prepFactor + ' forberedelsesfaktor'
    },
    numToFixed (num) {
      return parseFloat(num).toFixed(2)
    },
    createTooltip (sumForYear) {
      const hoursInYear = this.numberOfWorkDays
      const hoursPerDay = sumForYear / hoursInYear
      const hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      const hoursPerDayFixed = this.numToFixed(hoursPerDay)
      const hoursForPeriodFixed = this.numToFixed(hoursForPeriod)
      return `${this.i18n.tooltip.explanation}<br></p><p><b>${this.i18n.tooltip.calculation}</b></p><p>${this.i18n.tooltip.forYear} ${sumForYear} ${this.i18n.tooltip.hours} / ${hoursInYear} ${this.i18n.tooltip.days} = ${hoursPerDayFixed} ${this.i18n.tooltip.hours} ${this.i18n.tooltip.per_day}</p><p>${this.i18n.tooltip.forPeriod} ${this.numberOfWorkDaysInPeriod} ${this.i18n.tooltip.work_days} * ${hoursPerDayFixed} ${this.i18n.tooltip.hours} ${this.i18n.tooltip.per_day} = ${hoursForPeriodFixed} ${this.i18n.tooltip.hours}</p>`
    },
    scaleIndicator (diff) {
      let color = 'rgba(62, 207, 142, 0.4)'
      let newDiff = parseFloat(diff)
      let indicatorPercentage = parseFloat(newDiff.toFixed(0))
      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
        indicatorPercentage = '0' + indicatorPercentage
      }
      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
        indicatorPercentage = '0' + (indicatorPercentage * -1)
      }
      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
        indicatorPercentage = indicatorPercentage * -1
      }
      if (newDiff === 0) {
        color = 'transparent'
      }
      if (newDiff < 0) {
        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')'
      }
      if (newDiff < -99) {
        color = 'rgba(250, 86, 90, 1)'
      }
      if (newDiff > 0) {
        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')'
      }
      if (newDiff > 99) {
        color = 'rgba(62, 207, 142, 1)'
      }
      return {'--bgScaleColor': color}
    }
  },
  beforeDestroy () {
    if (this.$refs.popper_child) {
      this.$refs.popper_child.remove()
    }
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.user-table-container {
  max-width: 100%;
  max-height: calc(100vh - 190px);
  overflow: scroll;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
}

.user-table {
  width: 100%;
  color: #3d4340;
  border-collapse: inherit;
  border-spacing: 0;
}

.user-table th {
  color: #3d4340;
  font-weight: bold;
  position: sticky;
  z-index: 1;
  top: 0;
}

.user-table thead tr:first-child th:first-child {
  padding-left: 20px;
  cursor: pointer;
}

.user-table tbody tr:nth-child(odd) {
  background-color: #f8fafb;
}

.user-table tbody tr td {
  padding: 0 18px;
  border-top: 1px solid #ffffff;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  text-align: center;
}

.user-table thead tr:first-child th:first-child,
.user-table tbody tr td:first-child {
  text-align: left;
  width: 200px;
}

.user-table th {
  border-collapse: collapse;
  border-bottom: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  padding: 4px;
  text-align: center;
}


.user-table tr:first-child th:nth-child(1) {
  border-right: none;
}

.user-table tr:first-child th:nth-child(2),
.user-table tr:nth-child(2) th:nth-child(1) {
  border-left: 1px solid #d8d8d8;
}

.working-hours,
.assigned_total_hours,
.actual_total_hours,
.diff_total_hours {
  background: #f6f9fe;
}

.teaching-hours,
.assigned_teaching_hours,
.actual_teaching_hours,
.diff_teaching_hours {
  background: #f2f2ff;
}

.task-hours,
.assigned_additional_task_hours,
.actual_additional_task_hours,
.diff_additional_task_hours {
  background: #fffbf1;
}

.prep-hours,
.assigned_preparation_hours,
.actual_preparation_hours,
.diff_preparation_hours,
.assigned_pool_hours,
.actual_pool_hours,
.diff_pool_hours {
  background: #fefefe;
}

.absence-hours,
.actual_absence_hours {
  background: #f7f6f6;
}

.sub-hours,
.substitute_pool_hours,
.actual_substitute_hours,
.diff_substitute_hours {
  background: #f1fafb;
}

.club-hours,
.assigned_club_hours,
.actual_club_hours,
.diff_club_hours {
  background: #fef7f4;
}

.number__input-opened {
  position: absolute;
  top: 10%;
  left: 10%;
  display: flex;
  align-items: stretch;
  z-index: 1;
  background: #ffffff;
  padding: 0;
  box-shadow: 0 1px 3px 0 rgb(27 36 50 / 15%);
}

.number__input-opened input {
  width: 100px !important;
  border-radius: 4px 0 0 4px;
}

.number__input-opened button {
  height: auto;
  border-radius: 0 4px 4px 0;
  width: 65px !important;
}

.scale-enter-active {
  transition: transform 0.15s;
}

.scale-enter, .scale-leave-to {
  transform: scale(0.5);
}

.bttn.bttn--primary.bttn--primary--spinner {
  background-color: #edf0f5 !important;
}

.rest-hours,
.rest_hours {
  background: #fff;
}

/* th-sorter (tidligere AssignHoursAllUsersTheadTh) */

.th-sorter {
  transition: transform 0.25s;
  cursor: pointer;
  user-select: none;
  color: #3d4340;
  font-weight: bold;
  position: sticky;
  z-index: 3;
  top: 31px !important;
}

.th-sorter.active {
  color: var(--blue);
}

.th-sorter > span {
  opacity: 0.3;
}

.th-sorter:active {
  transform: scale(0.95);
}

.th-sorter.active > span {
  opacity: 1;
}

.column-width {
  min-width: 90px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.th-sorter.name .column-width {
  min-width: 200px;
  max-width: 200px;
}

.th-sorter.name {
  position: -webkit-sticky;
  position: sticky;
  z-index: 3;
  top: 0 !important;
  left: 0;
  border-collapse: collapse;
  background: #ffffff;
}

/* tr-user (tidligere AssingHoursAllUsersUserPerf) */

.tr-user {
  content-visibility: auto;
  contain-intrinsic-size: 1px 50px;
  height: 50px;
  align-items: center;
}

.tr-user:hover, .tr-user--active {
  border: 1px solid var(--blue);
  background: #eeeeee !important;
}

.tr-user.tr-user--active th, .tr-user:hover th {
  background: #eeeeee !important;
}

.tr-user th {
  position: sticky;
  z-index: 2;
  left: 0;
  border-collapse: collapse;
  background: #ffffff;
}

.tr-user:nth-child(odd) th {
  background: #f8fafb;
}

.number {
  position: relative;
  padding: 0 16px;
  text-align: right;
  border-bottom: 1px solid #d8d8d8 !important;
}

.number__scale-indicator:before {
  content: attr(aria-label);
  position: absolute;
  font-weight: normal;
  z-index: 0;
  top: 10%;
  left: 10%;
  right: 20%;
  bottom: 10%;
  width: 70%;
  height: 80%;
  background: var(--bgScaleColor);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 12px;
  padding-right: 10%;
}

.user-table th.tr-user__name {
  text-align: left;
  width: 200px;
  border-collapse: collapse;
  border-bottom: 1px solid #d8d8d8;
  padding: 0.5rem 1rem;
}

.tr-user__name__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tr-user__name__inner > p {
  width: 165px;
  overflow: hidden;
  line-height: 1;
}

.tr-user__name__bttn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.number_edit {
  cursor: pointer;
}

.number_edit:hover {
  text-decoration: underline;
  color: var(--blue);
}

.tr-user--cant-edit .number_edit:not(.td-sub-hours) {
  cursor: default;
  text-decoration: none !important;
  color: initial !important;
}

.user-table__body tr td.td-presence {
  background: var(--presenceColor);
  border: 0;
}

.user-table__body tr td.td-teaching {
  background: var(--teachingColor);
  border: 0;
}

.user-table__body tr td.td-tasks {
  background: var(--taskColor);
  border: 0;
}

.user-table__body tr td.td-preparation {
  background: var(--prepTimeColor);
  border: 0;
}

.user-table__body tr td.td-absence {
  background: var(--absenceColor);
  border: 0;
}

.user-table__body tr td.td-sub-hours {
  background: var(--subColor);
  border: 0;
}

.user-table__body tr td.td-club {
  background: var(--clubColor);
  border: 0;
}

.tw-icon {
  width: 1.7rem;
}

.secondary {
  fill: #0D2B3E;
}

.primary {
  fill: #a5b3bb;
}

.number:before {
  content: attr(aria-label);
  position: absolute;
  font-weight: normal;
  z-index: 0;
  top: 10%;
  left: 10%;
  right: 20%;
  bottom: 10%;
  width: 70%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 12px;
  padding-right: 10%;
}

.is-number--calculated {
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// AssignHoursAllUsersFlat.vue?450d6d7e